import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/bootstrap.min.css';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';

import App from './layouts/App';

import './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

